import CookieHelper from '@/helpers/CookieHelper';

export default class SingleIncentiveHelper {
  public static downloadDownlineOrBoosterRankingDetails(type: string, incentiveId: number): void {
    window.open(`/ref/downloads?idincentive=${incentiveId}&typ=${type}&mode=incentive_export`, `_blank`);
  }

  public static getMonthNameByMonth(currentDate: Date, month = 0): string {
    const dateOfMonth = new Date(Date.UTC(
      currentDate.getUTCFullYear(),
      month >= 1 && month <= 12 ? month - 1 : currentDate.getUTCMonth(),
      currentDate.getUTCDate(),
      0,
      0,
      0,
    ));
    return dateOfMonth.toLocaleDateString(CookieHelper.getLanguage(), { month: `long` });
  }
}
